import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Step } from '../../../../shared/models/internal/step';
import { NgClass } from '@angular/common';
import { AgentActionDirective } from '../../../directives/agent-action.directive';

@Component({
  selector: 'app-stepper',
  imports: [NgClass, AgentActionDirective],
  templateUrl: './stepper.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './stepper.scss',
})
export class Stepper implements OnChanges {
  @Input() public steps: Step[] = [];
  @Output() public stepChange = new EventEmitter<number>();
  @Output() public stepBack = new EventEmitter<void>();
  @Output() public stepNext = new EventEmitter<void>();
  @Output() public confirm = new EventEmitter<void>();
  @Output() public stepsCanceled = new EventEmitter<void>();

  private _steps: Step[] = [];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['steps'] && changes['steps'].currentValue) {
      this._steps = changes['steps'].currentValue;
    }
  }

  protected get isLastStepActive(): boolean {
    if (this._steps.length === 0) {
      return false;
    } else {
      return this._steps[this._steps.length - 1].isActive;
    }
  }

  protected get isFirstStepActive(): boolean {
    if (this._steps.length === 0) {
      return false;
    } else {
      return this._steps[0].isActive;
    }
  }

  protected next(): void {
    const currentIndex = this._steps.findIndex((step) => step.isActive);
    if (currentIndex < this._steps.length - 1) {
      this._steps[currentIndex].isActive = false;
      this._steps[currentIndex + 1].isActive = true;
      this.stepNext.emit();
      this.stepChange.emit(this._steps[currentIndex + 1].index);
    }
  }

  protected previous(): void {
    const currentIndex = this._steps.findIndex((step) => step.isActive);
    if (currentIndex > 0) {
      this._steps[currentIndex].isActive = false;
      this._steps[currentIndex - 1].isActive = true;
      this.stepBack.emit();
      this.stepChange.emit(this._steps[currentIndex - 1].index);
    }
  }

  protected confirmSteps(): void {
    this.confirm.emit();
  }

  protected cancelSteps(): void {
    this.stepsCanceled.emit();
  }
}
